const breadcrumbsHome = { name: 'Home', pathName: '/home', onlyAvailableOnVue2: true }
const breadcrumbsIndustria = { name: 'Indústria', pathName: null, action: 'industria' }

export default [
  {
    path: '/v3/industria',
    name: 'Industria',
    children: [
      {
        path: 'resultados-gerais',
        name: 'GeneralResults',
        component: () => import('@/modules/industria/resultados-gerais/views/GeneralResults.vue'),
        meta: {
          title: 'Resultados Gerais',
          requiredModules: ['industry'],
          allowOnlyMercapromo: true,
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsIndustria,
            {
              name: 'Resultados gerais',
              pathName: null,
            },
          ],
        },
      },
      {
        path: 'sms-trade',
        name: 'sms-trade',
        component: () => import('@/modules/industria/sms-trade/views/pages/Index.vue'),
        meta: {
          title: 'SMS de trade',
          requiredModules: ['industry'],
          requiredUserPermissions: ['industria/sms_trade'],
          allowOnlyMercapromo: true,
          breadcrumbs: [
            breadcrumbsHome,
            breadcrumbsIndustria,
            {
              name: 'SMS de trade',
              pathName: null,
            },
          ],
        },
      },
    ],
  },
]
